export enum CHARGE_STATUS {
  PENDING = 'PENDING',
  PAID = 'PAID',
  OVERDUE = 'OVERDUE',
  CANCELED = 'CANCELED',
  REFUNDED = 'REFUNDED',
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
  IN_DISPUTE = 'IN_DISPUTE',
  PAYMENT_REPORTED = 'PAYMENT_REPORTED',
}
